import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useUser } from "../../../context/UserContext";
import "./../GlobalContacts/SavedGlobalContacts.css";
import SavedContactTab from "../GlobalContacts/SavedContactTab";
import SavedContactContent from "../GlobalContacts/SavedContactContent";
import GenericTable from "../genericComponents/genericTableComp/GenericTable";
import ScHeaderComp from "../genericComponents/genericTableComp/genericTableScHeader/ScHeaderComp";
import GlobalAccountSearchSideCard from "./GlobalAccountSearchComps/GlobalAccountSearchSideCard";
import { useDispatch, useSelector } from "react-redux";
import { fetchGlobalAccounts } from "../../../services/authService";
import { FetchGlobalAccountsRequest } from "../../../store/features/actions/globalAccounts/globalAccountsActions";
import TextWithTooltip from "../GlobalContacts/TextWithTooltip";
import ResizableDivForTag from "../uiUtils/resizeobs/ResizableDivForTag";
import companyTypeMap from "./companyType.json";

// import SavedContactTab from "./SavedContactTab";
// import SavedContactContent from "./SavedContactContent";

const VerticalTabsSkeleton = () => {
  return (
    <div className="sgc-tabs-skeleton">
      {[...Array(15)].map((_, i) => (
        <div key={i} className="sgc-tab-skel-line" />
      ))}
    </div>
  );
};

const SavedContactContentSkeleton = () => {
  return (
    <div className="sgc-content-skeleton">
      <div className="sgc-skel-header"></div>

      <div className="sgc-skel-table">
        {[...Array(15)].map((_, rowIndex) => (
          <div key={rowIndex} className="sgc-skel-row">
            {[...Array(4)].map((__, colIndex) => (
              <div key={colIndex} className="sgc-skel-cell"></div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

function SavedGlobalAccounts({ tabs = [], loading, handleDeleteList }) {
  
  const { user } = useUser();
  const dispatch = useDispatch();
  const { globalAccountsLoading, globalAccountsData } = useSelector(
    (state) => state.globalAccountsReducer
  );
  const [activeIndex, setActiveIndex] = useState(0);
  const [tabData, setTabData] = useState([]);
  const [currRow, setCurrRow] = useState();
  const tabConfig = [];
  const [activeTab, setActiveTab] = useState(tabConfig?.[0]?.key);
  const [showSideCard, setShowSideCard] = useState(false);

  const [companyData, setCompanyData] = useState({
    company_name: [],
    industries: [],
    yearfounded: [],
    country: [],
    employees: [],
    companytypeid: null, // this will be always an interger
    region:[]
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);

  const tableColumns = useMemo(
    () => [
      
      {
        id: "company_name",
        label: "Name",
        width: 100,
        clickAction: true,
        alignment: "left",
      },
        {
        id: "description",
        label: "Description",
        width: 120,
        clickAction: true,
        alignment: "left",
      },
      {
        id: "industries",
        label: "Industries",
        width: 70,
        alignment: "flex-start",
      },
      {
        id: "yearfounded",
        label: "Founded In",
        width: 70,
        alignment: "flex-start",
      },
      {
        id: "companytypeid",
        label: "Type",
        width: 100,
        alignment: "flex-start",
      },
      {
        id: "country",
        label: "Country",
        width: 60,
        alignment: "flex-start",
      },
      {
        id: "region",
        label: "Region",
        width: 100,
        alignment: "flex-start",
      },
      {
        id: "webpage",
        label: "Website",
        width: 60,
        alignment: "flex-start",
      },

      {
        id: "employees",
        label: "Employees",
        width: 60,
        alignment: "flex-start",
      },
    ],
    [globalAccountsData?.docs]
  );

  const handleOnPageChange = (page) => {
    setCurrentPage(page);
  };

  const buildFilters = (data) => {
    const filters = [];
    const activeTabData = tabs[activeIndex];
    const company_ids = activeTabData?.company_ids || []
    if (!company_ids){
      return {}
    }

    // const formatArray = (arr) => {
    //   if (!Array.isArray(arr) || arr.length === 0) return null;
    //   const values = arr.map(item => item.label ?? item);
    //   const wrapped = values.map(v => `"${v}"`).join(" OR ");
    //   return `${wrapped}`;
    // };

    const formatArray = (arr) => {
      if (!Array.isArray(arr) || arr.length === 0) return null;
      const values = arr.map(v => `"${v.label ?? v}"`);
      // single value → no parentheses
      if (values.length === 1) {
        return values[0];
      }
      // multiple values → OR + parentheses
      return `(${values.join(" OR ")})`;
    };

    if(company_ids.length){
      filters.push(`companyid:(${formatArray(company_ids)})`);
    }

    if (data.country?.length)
      filters.push(`country:(${formatArray(data.country)})`);

    if (data.industries?.length)
      filters.push(`industries:(${formatArray(data.industries)})`);

    if (data.yearfounded?.length)
      filters.push(`yearfounded:(${formatArray(data.yearfounded)})`);

    if (data.company_name?.length)
      filters.push(`company_name:(${formatArray(data.company_name)})`);

    // ✅ Employees Range Handling
    if (Array.isArray(data.employees) && data.employees.length > 0) {
      if (data.employees.length === 2) {
        const [a, b] = data.employees.map(v => v.label ?? v);
        filters.push(`employees:[${a} TO ${b}]`);
      } else if (data.employees.length === 1) {
        const val = data.employees[0].label ?? data.employees[0];
        filters.push(`employees:${val}`);
      }else{
        filters.push(`employees:(${formatArray(data.employees)})`);
      }
    }

    if (data.region?.length)
      filters.push(`region:(${formatArray(data.region)})`);

    if (data.companytypeid !== null && data.companytypeid !== undefined)
      filters.push(`companytypeid:${data.companytypeid}`);

    return filters;
  };
  useEffect(() => {
    
    const fq = buildFilters(companyData);
  
    dispatch(
      FetchGlobalAccountsRequest({
        start: ((currentPage-1) * itemsPerPage),
        rows: itemsPerPage,
        q: "*:*",
        fq : fq,
      })
    );
  
    // console.log("companyData : ", companyData)
    // alert(currentPage)
  
  }, [currentPage, itemsPerPage, companyData, tabs, activeIndex]);

  const handleSideCard = useCallback((e, item, tabId) => {
    // console.log(item._id)
    e.preventDefault();
    e.stopPropagation();
    setShowSideCard(true);

    setCurrRow(item);
    setActiveTab(tabId || "nuture_activity");
  }, []);

  useEffect(() => {
      const filtered = globalAccountsData?.docs;
  
      const enhanced = filtered?.map((item) => ({
        ...item,
        company_name: (
          
          <span onClick={(e) => handleSideCard(e, item)}>
          <TextWithTooltip  className = "two-line-ellipsis_companyname" text={item?.company_name}/>
          </span>
        ),
        description: (
          <TextWithTooltip
            className={"two-line-ellipsis"}
            text={item?.description?.[0]}
          />
        ),
        // Ensure there is a unique ID for selection to work
        id: item.id || item._id,
  
        industries: (
          <ResizableDivForTag
            handleSideCard={(e) => handleSideCard(e, item)}
            items={(Array.isArray(item?.industries)
              ? item?.industries
              : typeof item?.industries === "string"
              ? item?.industries.split(",")?.map((s) => s.trim())
              : []
            )?.map((e) => ({ key: e, label: e }))}
            rowData={item}
          />
        ),
        companytypeid: (
          <TextWithTooltip
            className="one-line-ellipsis-companytype"
            text={
              Array.isArray(item?.companytypeid)
                ? item?.companytypeid
                    .map((id) => companyTypeMap?.[id] || `Unknown (${id})`+new Date().getTime())
                    .join(", ")
                : companyTypeMap[item?.companytypeid] || item?.companytypeid || ""
            }
          />
        ),
        region:<TextWithTooltip
            className={"two-line-ellipsis"}
            text={item?.region}
          />,
        country:<TextWithTooltip
            className={"two-line-ellipsis"}
            text={item?.country}
          />,
  
        webpage:  <TextWithTooltip
            className={"one-line-ellipsis"}
            text={item?.webpage}
          />,
        employees: <TextWithTooltip
            className={"two-line-ellipsis"}
            text={item?.employees ? Math.round(item?.employees) : ""}
          />,
      }));
  
      setTabData(enhanced);
      console.log("globalAccountsData", globalAccountsData);
    }, [globalAccountsData]);

  const [selectedRows, setSelectedRows] = useState([]);
  
  const commonProps = {};
  const [activeSwitchId, setActiveSwitchId] = useState(null);
    // Data for calculations
  const totalAccounts = globalAccountsData ? globalAccountsData?.numFound : 0;
  // const totalAccounts = tabs[activeIndex]?.company_ids?.length || 0;
  const selectedCount = selectedRows.length;

  // ---- Fetch Saved Contacts ----

  // ---- UI States ----
  if (loading) {
    return (
      <div className="sgc-wrapper">
        <div className="sgc-tabs-list">
          <VerticalTabsSkeleton />
        </div>
        <div className="sgc-content-area">
          <SavedContactContentSkeleton />
        </div>
      </div>
    );
  }

  if (!tabs.length)
    return <div className="sgc-no-data">No saved accounts found.</div>;



  const activeTabData = tabs[activeIndex];

  console.log("activeTabData : ", activeTabData)

  return (
    <div className="sgc-wrapper">
      {/* ---------- LEFT: TAB LIST ---------- */}
      <div className="sgc-tabs-list">
        {tabs?.map((item, index) => (
          <div
            key={item?._id ?? index}
            className={`sgc-tab ${index === activeIndex ? "active" : ""}`}
            onClick={() => setActiveIndex(index)}
          >
            <SavedContactTab
              content={item}
              list_type="global_accounts"
              onDelete={handleDeleteList}
              defaultList={item?.defaultList === true}
            />
          </div>
        ))}
      </div>

      {/* ---------- RIGHT: TAB CONTENT ---------- */}
      <div className="sgc-content-area">
        <GenericTable
        disableSort={true}
        enablePagination={true}
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        onPageChange={handleOnPageChange}
        totalItems={totalAccounts}
        initialColumns={tableColumns}
        tabData={tabData}
        onModalClose={() => {}}
        loading={globalAccountsLoading}
        allowSelection={true}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        loadingRows={15}
        minWidthForDrawer={"60%"}
        setShowMoreModal={setShowSideCard}
        showMoreModal={showSideCard}
        titleForSideCard={
          <ScHeaderComp
            key={`side_card_global_acc_head_comp`}
            type="auto_nurture"
            opportunityId={commonProps?.opportunityId}
            data={currRow}
            titlkey={"objective"}
            titlTxt={currRow?.company_name}
            setShowMoreModal={setShowSideCard}
            activeTab={activeTab}
          />
        }
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        activeSwitchId={activeSwitchId}
        customComp={<GlobalAccountSearchSideCard data={currRow} companyName={currRow?.company_name} />}
      />
      </div>
    </div>
  );
}

export default SavedGlobalAccounts;
